(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pdc-design-express"]) return;
  try {
    
function initExpressSections() {
  document.querySelectorAll('.pdc-express').forEach(root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const comparison = root.querySelector('[data-ex-compare-images]');
    if (comparison) {
      const range = comparison.querySelector('.ex-compare-range');
      const frame = comparison.querySelector('.ex-compare-frame');
      const beforeLabel = comparison.querySelector('[data-ex-before-label]');
      const afterLabel = comparison.querySelector('[data-ex-after-label]');
      const updateComparison = () => {
        const value = Math.min(100, Math.max(0, Number(range.value)));
        frame.style.setProperty('--ex-proposal', value + '%');
        range.setAttribute('aria-valuetext', range.dataset.exPercentText.replace('__VALUE__', String(value)));
        beforeLabel.hidden = value === 100;
        afterLabel.hidden = value === 0;
      };
      range.addEventListener('input', updateComparison);
      comparison.querySelectorAll('[data-ex-compare-value]').forEach(button => {
        button.addEventListener('click', () => {
          range.value = button.dataset.exCompareValue;
          updateComparison();
        });
      });
      updateComparison();
      comparison.querySelector('.ex-compare-controls').hidden = false;
    }
    const primary = root.querySelector('[data-ex-primary]');
    const bar = root.querySelector('.ex-mobile-bar');
    if (primary && bar && 'IntersectionObserver' in window) {
      let primaryAbove = false, sectionVisible = true;
      const syncBar = () => { bar.hidden = !primaryAbove || !sectionVisible; };
      new IntersectionObserver(entries => {
        primaryAbove = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
        syncBar();
      }, {threshold:0}).observe(primary);
      new IntersectionObserver(entries => { sectionVisible = entries[0].isIntersecting; syncBar(); }, {threshold:0}).observe(root);
    }
    const variants = JSON.parse(root.querySelector('[data-ex-variants]').textContent);
    const select = root.querySelector('select[name="id"]');
    if (select) select.addEventListener('change', () => {
      const variant = variants.find(v => String(v.id) === select.value);
      if (!variant) return;
      root.querySelectorAll('[data-ex-price]').forEach(el => { el.textContent = variant.price; });
      root.querySelectorAll('button[type="submit"]').forEach(el => { el.disabled = !variant.available; });
      const compare = root.querySelector('[data-ex-compare]');
      if (compare) compare.hidden = true;
    });
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initExpressSections);
else initExpressSections();
document.addEventListener('shopify:section:load', initExpressSections);

  } catch(e) { console.error(e); }
})();
})();
